import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookinginpcmcpune() {



    const cardData = {

keyword: "Online Cab Booking in PCMC Pune",

headingDescription:
    "Rising Cab Service provides fast, reliable, and convenient Online Cab Booking in PCMC Pune for daily travel, airport transfers, railway station pickups, and outstation journeys. Customers can book cabs instantly or in advance with a wide range of vehicles including Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury cars. With professional drivers, 24/7 availability, doorstep pickup across PCMC areas like Pimpri, Chinchwad, Wakad, Hinjewadi, and Ravet, and transparent pricing, we ensure a safe and comfortable travel experience for every ride.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular weekend getaway destinations near PCMC, known for misty hills, waterfalls, green valleys, and scenic viewpoints like Tiger Point and Bhushi Dam. These twin hill stations are ideal for short drives, monsoon trips, and family outings, making them the most frequently booked cab routes from PCMC."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a beautiful hill station famous for strawberry farms, dense forests, and panoramic viewpoints like Arthur’s Seat and Elephant’s Head Point. It is a perfect long weekend destination from PCMC for families and couples looking for a cool climate and scenic drive."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of the most important pilgrimage destinations in India, dedicated to Sai Baba. Devotees travel from PCMC for Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi to experience spiritual peace and darshan."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a major religious and cultural destination near PCMC, known for Trimbakeshwar Jyotirlinga, Panchavati temples, and the Godavari river ghats. It also offers vineyard tours at Sula and other wineries, making it a mix of spirituality and leisure travel."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills, surrounded by dense forest and wildlife. It is a popular destination for both pilgrims and trekkers traveling from PCMC seeking spiritual darshan and nature experiences."
    },
    {
        title: "Lavasa",
        description:
            "Lavasa is a planned hill city near Pune known for its lakeside promenade, colorful architecture, boating activities, and peaceful environment. It is a short and comfortable weekend drive from PCMC, ideal for relaxation trips."
    },
    {
        title: "Matheran",
        description:
            "Matheran is an eco-friendly hill station known for its toy train, vehicle-free environment, and scenic viewpoints. It is a unique travel destination from PCMC offering peaceful nature walks and mountain views."
    },
    {
        title: "Goa",
        description:
            "Goa is a long-distance holiday destination from PCMC famous for beaches, nightlife, water sports, forts, and coastal drives. It is one of the most booked outstation cab routes for group trips and vacations."
    },
    {
        title: "Tamhini Ghat",
        description:
            "Tamhini Ghat is a scenic mountain pass near PCMC known for waterfalls, fog-covered valleys, and lush greenery during monsoon. It is one of the best short road trip routes for nature lovers."
    },
    {
        title: "Alandi",
        description:
            "Alandi is a holy pilgrimage town near PCMC associated with Sant Dnyaneshwar Maharaj. It is frequently visited by devotees for peaceful temple darshan and spiritual trips from nearby cities."
    }
],



services: [
{
name: "Online Cab Booking in PCMC Pune",
description: "Rising Cab Service offers Online Cab Booking in PCMC Pune for fast, reliable, and convenient travel across Pimpri Chinchwad and nearby Pune areas. Choose from AC Sedan, SUV, Innova Crysta, Kia Carens, and Tempo Traveller with professional drivers, doorstep pickup, and 24x7 availability for local and outstation travel."
},
{
name: "PCMC Cab Booking Online",
description: "Book PCMC Cab Booking Online with Rising Cab Service for instant confirmation, easy reservation, and transparent pricing. Ideal for daily commuting, airport transfers, and long-distance outstation travel with comfortable vehicles and experienced chauffeurs."
},
{
name: "Pimpri Chinchwad Cab Service",
description: "Our Pimpri Chinchwad Cab Service ensures safe, comfortable, and affordable travel within PCMC and Pune. We provide clean vehicles, verified drivers, and reliable service for families, professionals, and corporate clients."
},
{
name: "Online Taxi Booking PCMC",
description: "Rising Cab Service provides Online Taxi Booking PCMC for quick and hassle-free cab reservations with real-time availability, fast response, and smooth travel experience across city and outstation routes."
},
{
name: "Cab Service in Pimpri Chinchwad",
description: "Book Cab Service in Pimpri Chinchwad for reliable local travel, airport transfers, and outstation trips with well-maintained vehicles and professional drivers ensuring safe and timely journeys."
},
{
name: "PCMC Taxi Service",
description: "Our PCMC Taxi Service offers comfortable and affordable transportation solutions across Pimpri Chinchwad with 24x7 availability, flexible booking options, and experienced chauffeurs."
},
{
name: "Online Taxi Service PCMC Pune",
description: "Rising Cab Service provides Online Taxi Service PCMC Pune for easy booking, quick pickup, and safe travel experience with multiple vehicle options for all types of journeys."
},
{
name: "Pimpri Chinchwad Taxi Booking",
description: "Book Pimpri Chinchwad Taxi Booking for instant ride confirmation, affordable fares, and comfortable travel across PCMC and Pune with professional drivers."
},
{
name: "One Way Cab Service PCMC",
description: "Our One Way Cab Service PCMC offers budget-friendly drop-only travel for intercity routes with flexible pickup points and comfortable AC vehicles."
},
{
name: "Outstation Cab Booking PCMC",
description: "Rising Cab Service provides Outstation Cab Booking PCMC for safe long-distance travel to Mumbai, Goa, Nashik, Shirdi, and other destinations with experienced drivers and reliable service."
},
{
name: "Pimpri Cab Booking Online",
description: "Book Pimpri Cab Booking Online for fast and easy cab reservation with multiple vehicle options and instant confirmation for local and outstation travel."
},
{
name: "Chinchwad Taxi Service",
description: "Our Chinchwad Taxi Service ensures safe, reliable, and comfortable travel within PCMC and beyond with clean vehicles and professional chauffeurs."
},
{
name: "Online Cab Hire PCMC",
description: "Rising Cab Service offers Online Cab Hire PCMC for flexible travel options including hourly rental, one-way trips, and full-day bookings with AC cars and trained drivers."
},
{
name: "24x7 Cab Service PCMC",
description: "Book 24x7 Cab Service PCMC for round-the-clock availability ensuring safe and reliable transportation anytime across Pimpri Chinchwad and Pune."
},
{
name: "PCMC to Mumbai Cab",
description: "Our PCMC to Mumbai Cab service ensures smooth and comfortable intercity travel with experienced drivers, highway-safe vehicles, and flexible one-way or round-trip options."
},
{
name: "PCMC to Pune Airport Cab",
description: "Rising Cab Service provides PCMC to Pune Airport Cab for timely pickup and drop with clean vehicles and professional drivers ensuring stress-free airport travel."
},
{
name: "Innova Cab Service PCMC",
description: "Book Innova Cab Service PCMC for premium comfort, spacious seating, and smooth travel ideal for families and group journeys."
},
{
name: "Online Cab Booking Pimpri Chinchwad",
description: "Our Online Cab Booking Pimpri Chinchwad service ensures instant booking, easy confirmation, and reliable travel across PCMC with multiple vehicle options."
},
{
name: "PCMC Outstation Taxi Service",
description: "Rising Cab Service offers PCMC Outstation Taxi Service for safe and comfortable long-distance travel to major destinations with professional drivers."
},
{
name: "PCMC Corporate Cab Service",
description: "Book PCMC Corporate Cab Service for employee transportation, office travel, and business trips with punctual drivers and well-managed fleet services."
}
],

tableData: [
["Online Cab Booking in PCMC Pune","PCMC Cab Booking Online"],
["Pimpri Chinchwad Cab Service","Online Taxi Booking PCMC"],
["Cab Service in Pimpri Chinchwad","PCMC Taxi Service"],
["One Way Cab Service PCMC","Outstation Cab Booking PCMC"],
["PCMC to Mumbai Cab","PCMC to Pune Airport Cab"],
["Innova Cab Service PCMC","24x7 Cab Service PCMC"],
["Online Cab Hire PCMC","PCMC Corporate Cab Service"],
["Chinchwad Taxi Service","Pimpri Cab Booking Online"]
],



whychoose: [
    {
        WhyChooseheading: "Quick Online Cab Booking in PCMC Pune",
        WhyChoosedescription: "Rising Cab Service offers easy online cab booking solutions across Pimpri Chinchwad for local travel, airport transfers, outstation trips, and corporate transportation."
    },
    {
        WhyChooseheading: "Fast Confirmation and Hassle-Free Reservations",
        WhyChoosedescription: "Customers can schedule their rides in advance and receive prompt booking assistance for planned journeys and urgent travel requirements."
    },
    {
        WhyChooseheading: "Coverage Across All PCMC Locations",
        WhyChoosedescription: "Online bookings are available from Pimpri, Chinchwad, Nigdi, Akurdi, Ravet, Punawale, Tathawade, Wakad, Pimple Saudagar, Bhosari, Moshi, and nearby areas."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Travel",
        WhyChoosedescription: "Whether you need a cab within PCMC or are planning travel to Mumbai, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, or other destinations, we provide flexible travel options."
    },
    {
        WhyChooseheading: "Multiple Vehicle Categories Available",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles based on passenger requirements."
    },
    {
        WhyChooseheading: "Perfect for Airport and Railway Transfers",
        WhyChoosedescription: "Our online booking service is frequently used for Pune Airport transfers, railway station pickups, business travel, and family transportation."
    },
    {
        WhyChooseheading: "Comfortable and Well-Maintained Fleet",
        WhyChoosedescription: "Every vehicle is maintained for cleanliness, passenger comfort, and reliable performance to ensure a pleasant travel experience."
    },
    {
        WhyChooseheading: "Preferred by Families and Corporate Clients",
        WhyChoosedescription: "Rising Cab Service is trusted by families, professionals, tourists, students, and business travelers throughout the PCMC region."
    }
]
};

const faqData = [
    {
        question: "What is Online Cab Booking in PCMC Pune?",
        answer: "Online Cab Booking allows customers to reserve taxis for local travel, airport transfers, outstation journeys, sightseeing tours, and business transportation."
    },
    {
        question: "Which PCMC areas are covered under your cab service?",
        answer: "Our service covers Pimpri, Chinchwad, Wakad, Ravet, Punawale, Nigdi, Akurdi, Bhosari, Moshi, Pimple Saudagar, Tathawade, and nearby locations."
    },
    {
        question: "Can I book an airport cab online from PCMC?",
        answer: "Yes, customers can reserve airport pickup and drop services for Pune Airport through our online booking facility."
    },
    {
        question: "Are outstation cab bookings available online?",
        answer: "Yes, online reservations are available for destinations across Maharashtra and various cities throughout India."
    },
    {
        question: "What vehicle options can be booked online?",
        answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Can I schedule a cab for corporate travel?",
        answer: "Yes, businesses and professionals regularly use our online booking service for meetings, employee transportation, and official travel."
    },
    {
        question: "Do you provide railway station pickup services?",
        answer: "Yes, online bookings are available for Pune Railway Station and other nearby railway terminals."
    },
    {
        question: "Can larger groups book Tempo Travellers online?",
        answer: "Yes, Tempo Travellers and group vehicles can be reserved online for tours, events, and family travel."
    },
    {
        question: "Is advance booking available for future travel dates?",
        answer: "Yes, customers can reserve vehicles in advance for weekends, holidays, tours, and special occasions."
    },
    {
        question: "How can I complete an Online Cab Booking in PCMC Pune?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sagar Bhosale",
        feedback:
            "Reserving a cab online from Wakad was extremely simple. The confirmation arrived quickly, and the vehicle reached right on schedule.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Prajakta Khandekar",
        feedback:
            "The online booking process was smooth and convenient. From Pimple Saudagar to Pune Airport, the entire journey was handled professionally and comfortably.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Online Cab Booking in PCMC Pune",
"image": "https://www.risingcabservice.com/assets/images/pcmc-cab-booking.jpg",
"description": "Book Online Cab Booking in PCMC Pune with Rising Cab Service for local, airport, and outstation travel. Enjoy reliable 24x7 taxi service in Pimpri Chinchwad with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/online-cab-booking-pcmc"
}
};


    return (
        <div>


<Helmet>
  <title>Online Cab Booking in PCMC Pune | 24x7 Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Online Cab Booking in PCMC Pune with Rising Cab Service. Get 24x7 reliable taxi service for local, airport, and outstation travel in Pimpri Chinchwad."
/>

<meta
 name="keywords"
 content="Online Cab Booking in PCMC Pune, PCMC Cab Booking Online, Pimpri Chinchwad Cab Service, Online Taxi Booking PCMC, Cab Service in Pimpri Chinchwad, PCMC Taxi Service, Online Taxi Service PCMC Pune, Pimpri Chinchwad Taxi Booking, One Way Cab Service PCMC, Outstation Cab Booking PCMC, Pimpri Cab Booking Online, Chinchwad Taxi Service, Online Cab Hire PCMC, 24x7 Cab Service PCMC, PCMC to Mumbai Cab, PCMC to Pune Airport Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onlinecabbookinginpcmcpune;